<corp-menu-primary></corp-menu-primary>
<main role="main" class="container">
  <div class="row">
    <router-outlet></router-outlet>
  </div>
</main>
